import defaultApi from '@/utils/request';

export default {
  // 加載列表
  /* -------------------- 新生基本資料登錄作業 Start -------------------- */
  S30W2001_CheckNewStudent(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2001_CheckNewStudent',
      params,
    });
  },
  S30W2001_BasicViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2001_BasicViewLoad',
      params,
    });
  },
  S30W2001_BasicViewUpdate(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S30/S30W2001_BasicViewUpdate',
      data,
    });
  },
  S30W2001_BasicViewFileUpload(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S30/S30W2001_BasicViewFileUpload',
      data,
    });
  },
  S30W2001_BankViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2001_BankViewLoad',
      params,
    });
  },
  S30W2001_BankViewUpdate(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S30/S30W2001_BankViewUpdate',
      data,
    });
  },
  S30W2001_BankSearchViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2001_BankSearchViewLoad',
      params,
    });
  },
  S30W2001_InfoAndEduViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2001_InfoAndEduViewLoad',
      params,
    });
  },
  S30W2001_InfoAndEduViewUpdate(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S30/S30W2001_InfoAndEduViewUpdate',
      data,
    });
  },
  S30W2001_ZipCitySelectorLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2001_ZipCitySelectorLoad',
      params,
    });
  },
  S30W2001_SchoolSearchViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2001_SchoolSearchViewLoad',
      params,
    });
  },
  S30W2001_DeptSearchViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2001_DeptSearchViewLoad',
      params,
    });
  },
  S30W2001_MilitaryViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2001_MilitaryViewLoad',
      params,
    });
  },
  S30W2001_MilitaryViewUpdate(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S30/S30W2001_MilitaryViewUpdate',
      data,
    });
  },
  S30W2001_ParentViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2001_ParentViewLoad',
      params,
    });
  },
  S30W2001_ParentViewUpdate(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S30/S30W2001_ParentViewUpdate',
      data,
    });
  },
  S30W2001_FamilyViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2001_FamilyViewLoad',
      params,
    });
  },
  S30W2001_FamilyEditViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2001_FamilyEditViewLoad',
      params,
    });
  },
  S30W2001_FamilyEditViewAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S30/S30W2001_FamilyEditViewAction',
      data,
    });
  },
  S30W2001_PayViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2001_PayViewLoad',
      params,
    });
  },
  S30W2001_PayViewUpdate(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S30/S30W2001_PayViewUpdate',
      data,
    });
  },
  S30W2001_FinishViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2001_FinishViewLoad',
      params,
    });
  },
  /* -------------------- 新生基本資料登錄作業 End -------------------- */
  S30W2002_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2002_Load',
      params,
    });
  },
  S30W2002_EditViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2002_EditViewLoad',
      params,
    });
  },
  S30W2002_EditViewAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S30/S30W2002_EditViewAction',
      data,
    });
  },
  S30W2002_FileListLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2002_FileListLoad',
      params,
    });
  },
  S30W2002_FileAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S30/S30W2002_FileAction',
      data,
    });
  },
  S30W2003_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2003_Load',
      params,
    });
  },
  S30W2003_EditViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2003_EditViewLoad',
      params,
    });
  },
  S30W2003_EditViewAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S30/S30W2003_EditViewAction',
      data,
    });
  },
  S30W2003_FileListLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2003_FileListLoad',
      params,
    });
  },
  S30W2003_FileAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S30/S30W2003_FileAction',
      data,
    });
  },
  S30W2004_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2004_Load',
      params,
    });
  },
  S30W2004_Get_City(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2004_GetCity',
      params,
    });
  },
  S30W2004_Get_ZipCity(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2004_GetZipCity',
      params,
    });
  },
  S30W2004_Update_StuInfo(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S30/S30W2004_UpdateStuInfo',
      data,
    });
  },

  // ============================== S30W2005 ==================================
  S30W2005_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2005_Load',
      params,
    });
  },
  S30W2005_Get_Notice(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2005_Get_Notice',
      params,
    });
  },
  S30W2005_Get_ApplyData(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2005_Get_ApplyData',
      params,
    });
  },
  S30W2005_Get_reviewDetails(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2005_Get_reviewDetails',
      params,
    });
  },
  S30W2005_Get_StdList(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2005_Get_StdList',
      params,
    });
  },
  S30W2005_Check_Open(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2005_Check_Open',
      params,
    });
  },
  S30W2005_find_FirstVerify(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2005_find_FirstVerify',
      params,
    });
  },
  S30W2005_Get_applyInfo(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2005_Get_applyInfo',
      params,
    });
  },
  S30W2005_Get_prevGraduSch(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2005_Get_prevGraduSch',
      params,
    });
  },

  S30W2005_Post_apply(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S30/S30W2005_Post_apply',
      data,
    });
  },
  S30W2005_Abort_apply(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S30/S30W2005_Abort_apply',
      data,
    });
  },

  S30W2005_Get_reviewProcess(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2005_Get_reviewProcess',
      params,
    });
  },

  // ================== S30W2006 ===================================

  S30W2006_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2006_Load',
      params,
    });
  },
  S30W2006_Get_Notice(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2006_Get_Notice',
      params,
    });
  },
  S30W2006_Get_ApplyData(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2006_Get_ApplyData',
      params,
    });
  },
  S30W2006_Get_applyCnt(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2006_Get_applyCnt',
      params,
    });
  },
  S30W2006_Get_reviewProcess(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2006_Get_reviewProcess',
      params,
    });
  },
  S30W2006_Get_reviewDetails(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2006_Get_reviewDetails',
      params,
    });
  },
  S30W2006_Get_auditDetails(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2006_Get_auditDetails',
      params,
    });
  },
  S30W2006_Check_Open(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2006_Check_Open',
      params,
    });
  },
  S30W2006_Get_StdList(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2006_Get_StdList',
      params,
    });
  },
  S30W2006_Get_IsInschool(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2006_Get_IsInschool',
      params,
    });
  },
  S30W2006_Get_giveupReason(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2006_Get_giveupReason',
      params,
    });
  },
  S30W2006_Get_applyInfo(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2006_Get_applyInfo',
      params,
    });
  },
  S30W2006_Post_apply(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S30/S30W2006_Post_apply',
      data,
    });
  },
  S30W2006_Abort_apply(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S30/S30W2006_Abort_apply',
      data,
    });
  },

  // ===============================  S30W2007 ========================================
  S30W2007_Get_AuditData(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2007_GetAuditData',
      params,
    });
  },
  S30W2007_GetReviewListByID(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2007_GetReviewListByID',
      params,
    });
  },
  S30W2007_GetreviewDetails(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2007_GetreviewDetails',
      params,
    });
  },
  S30W2007_GetverifyData(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2007_GetverifyData',
      params,
    });
  },
  S30W2007_agreeApply(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S30/S30W2007_agreeApply',
      data,
    });
  },
  S30W2007_disagreeApply(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S30/S30W2007_disagreeApply',
      data,
    });
  },
  S30W2007_rejectAprove(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S30/S30W2007_rejectAprove',
      data,
    });
  },

  // ===============================  S30W2008 ========================================
  S30W2008_Get_AuditData(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2008_GetAuditData',
      params,
    });
  },
  S30W2008_GetReviewListByID(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2008_GetReviewListByID',
      params,
    });
  },
  S30W2008_GetreviewDetails(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2008_GetreviewDetails',
      params,
    });
  },
  S30W2008_GetverifyData(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2008_GetverifyData',
      params,
    });
  },
  S30W2008_agreeApply(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S30/S30W2008_agreeApply',
      data,
    });
  },
  S30W2008_disagreeApply(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S30/S30W2008_disagreeApply',
      data,
    });
  },
  S30W2008_rejectAprove(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S30/S30W2008_rejectAprove',
      data,
    });
  },
  S30W2008_GetverifyScore(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2008_GetverifyScore',
      params,
    });
  },
  S30W2008_submitVerify(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S30/S30W2008_submitVerify',
      data,
    });
  },

  // ===============================  S30W2009 ========================================
  S30W2009_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2009_Load',
      params,
    });
  },
  S30W2009_doUpdate(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S30/S30W2009_doUpdate',
      data,
    });
  },
  // 加載列表 // S30W2010畢業生離校手續單
  S30W2010_LoadList(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2010_LoadList',
      params,
    });
  },
  S30W2010_EditViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S30/S30W2010_EditViewLoad',
      params,
    });
  },
  S30W2010_EditViewAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S30/S30W2010_EditViewAction',
      data,
    });
  },
  S30W2010_SetOKAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S30/S30W2010_SetOKAction',
      data,
    });
  },

  // ===============================  S30W4001 需求表: 1120100081 ========================
  S30W4001_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S30/S30W4001_Load',
      params,
    });
  },
};
